import styled, { css } from "styled-components";
import { type WidthProps, width } from "styled-system";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import Container from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
// old components
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import * as Tag from "../../../../../../../../common-deprecated/styles/lexus/Tag";
import * as CustomizeCtaContainer from "../../../../../../../../common-deprecated/styles/v2/lexus/custom/CustomizeCtaContainer";
import * as CashPrice from "../../../common/price/styles/CashPrice";
import * as MonthlyPrice from "../../../common/price/styles/MonthlyPrice";
import { h2Style, h6Style } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { AvailabilityBadges } from "../../../../../../../../common-deprecated/components/aem/lexus/availability-badges/styles/AvailabilityBadgesStyles";

export const Wrapper = styled.div`
    position: relative;
    margin-top: ${theme.space[5]}px;
    margin-bottom: ${theme.space[5]}px;
    border-bottom: 1px solid ${theme.colors.silver};
    overflow: hidden;

    @media ${getBreakpoint("up", "lg")} {
        margin-top: 60px;
    }
`;

export const Toggle = styled.button<{ isFullscreen?: boolean; hasWinterWheel?: boolean }>`
    display: none;
    width: 32px;
    height: 32px;
    background: ${theme.colors.steel};

    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 12px 0 ${theme.space[2]}px;
    }

    ${IconWrapper} {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* Fix position icon in toggle button */
    .icon-enlarge {
        position: relative;
        left: 1px;
    }

    html[dir="rtl"] & {
        .icon-enlarge {
            left: auto;
            right: 1px;
        }
    }
`;

export const HeaderWrapper = styled.div<{ isFullscreen?: boolean; hasLightColors: boolean }>`
    position: relative;
    z-index: 6;
    @media ${getBreakpoint("up", "md")} {
        margin-bottom: ${theme.space[3]}px;
    }
    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            position: static;
            ${Container} {
                max-width: none;
                padding: ${theme.space[3]}px 0 0;
            }
        `};
`;

export const ExteriorSpinWrapper = styled(Flex.Col)<{
    isFullscreen?: boolean;
    hidden?: boolean;
    hasHeaderPrice?: boolean;
}>`
    display: flex;
    order: 3;
    z-index: 1;

    @media ${getBreakpoint("up", "lg")} {
        position: absolute;
        top: 0;
        right: 5%;
        order: unset;
    }

    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `};

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            display: flex;
            margin-top: 0;
            @media ${getBreakpoint("up", "lg")} {
                position: absolute;
                top: 100%;
                left: 0;
                right: auto;
                order: 3;
                width: 100%;
                transform: none;
            }
        `};

    html[dir="rtl"] & {
        @media ${getBreakpoint("up", "lg")} {
            left: 5%;
            right: auto;
        }
    }
`;

export const ResizeWrapper = styled.div<{ fullscreen: boolean }>`
    position: relative;
    ${({ fullscreen }) =>
        fullscreen &&
        css`
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            max-width: none;
            padding: 0 40px;
            background: ${theme.colors.white};
            z-index: ${theme.zIndex.popover};
            ${ExteriorSpinWrapper} {
                max-width: none;
            }
            ${HeaderWrapper} {
                top: ${theme.space[5]}px;
            }
        `};
`;

export const InteriorGalleryWrapper = styled(Container)<{ isFullscreen?: boolean }>`
    position: relative;

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            position: static;
            max-width: 100% !important;
            padding: 0;
        `};
`;

export const DisclaimerReference = styled.div`
    position: absolute;
    bottom: 0;
    right: 10px;
    font-size: 4rem;
    text-shadow: 2px 2px 2px ${theme.colors.platinumDark};
    color: ${theme.colors.white};

    @media ${getBreakpoint("down", "xl")} {
        right: 25px;
    }

    html[dir="rtl"] & {
        left: 10px;
        right: auto;
        @media ${getBreakpoint("down", "xl")} {
            left: 25px;
            right: auto;
        }
    }
`;

export const Header = styled(Flex.Row)`
    position: relative;
    justify-content: space-between;
    ${Tag.Eco} {
        margin-top: ${theme.space[2]}px;
        @media ${getBreakpoint("down", "md")} {
            position: absolute;
            top: 0;
            right: 24px;
        }
    }

    html[dir="rtl"] & {
        ${Tag.Eco} {
            @media ${getBreakpoint("down", "md")} {
                left: 24px;
                right: auto;
            }
        }
    }
`;

export const Title = styled.h1`
    margin: 0 0 ${theme.space[1]}px;
    text-transform: none;
    color: ${theme.colors.black};
    ${h2Style};
`;

export const ModelTitle = styled.h1`
    margin: 0;
    font-family: ${theme.fonts.regular};
    font-size: 2.8rem;
    letter-spacing: 0.2rem;
    line-height: 3.6rem;
    text-transform: none;
    color: ${theme.colors.black};

    @media ${getBreakpoint("up", "xl")} {
        font-size: 4rem;
        line-height: 5rem;
    }
`;

export const GradeTitle = styled.h2`
    margin: ${theme.space[1]}px 0;
    text-transform: uppercase;
    color: ${theme.colors.platinumDark};
    ${h6Style};
`;

export const Subtitle = styled.h2`
    margin: 0;
    text-transform: none;
    color: ${theme.colors.platinumDark};
    ${h6Style};
`;

export const PriceWrapper = styled.div`
    ${CashPrice.Text},
    ${MonthlyPrice.Text} {
        font-family: ${theme.fonts.regular};
        font-size: 1.4rem;
        line-height: 2rem;
        color: ${theme.colors.midnight};
    }
`;

export const Toolbar = styled.div<WidthProps>`
    position: relative;
    ${width};
    z-index: 10;
    ${CustomizeCtaContainer.Wrapper} {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
        padding: 0 0 ${theme.space[5]}px 0;
    }

    @media ${getBreakpoint("down", "md")} {
        ${CustomizeCtaContainer.Wrapper} > a {
            max-width: unset;
        }
    }

    @media ${getBreakpoint("up", "lg")} {
        ${CustomizeCtaContainer.Wrapper} {
            display: none;
        }
    }
`;

export const LeftCorner = styled(Flex.Col)<{ hasWinterWheel?: boolean }>`
    position: relative;
    flex-grow: 1;
    text-align: start;
    z-index: 10;

    ${Button.Link} {
        margin-bottom: ${theme.space[3]}px;
        font-family: ${theme.fonts.book};
        font-size: 1.3rem;
        letter-spacing: 0.15rem;
        text-transform: uppercase;
    }
    ${Tag.Eco} {
        display: none;
        position: relative;
        @media ${getBreakpoint("up", "lg")} {
            display: flex;
        }
    }

    @media ${getBreakpoint("up", "md")} {
        flex-grow: 0;
    }

    ${AvailabilityBadges} {
        margin-top: ${theme.space[2]}px;
    }
`;

export const RightCorner = styled(Flex.Col)<{
    isFullscreen?: boolean;
    hasLightColor?: boolean;
    hasWinterWheel?: boolean;
}>`
    display: ${({ hasWinterWheel }) => (hasWinterWheel ? "flex" : "none")};
    position: relative;
    flex: 1;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    text-align: end;
    z-index: 11;

    @media ${getBreakpoint("up", "lg")} {
        display: flex;
        flex: 0 1 auto;
        ${Tag.Eco} {
            display: none;
        }
    }

    ${CustomizeCtaContainer.Wrapper} {
        display: none;
        @media ${getBreakpoint("up", "lg")} {
            display: flex;
        }
    }

    ${({ isFullscreen }) =>
        isFullscreen &&
        css`
            flex-direction: column;
            ${Toggle} {
                margin-left: auto;
            }
            ${CustomizeCtaContainer.Wrapper} {
                display: none;
            }

            html[dir="rtl"] & {
                ${Toggle} {
                    margin-left: 0;
                    margin-right: auto;
                }
            }
        `};

    ${({ hasLightColor }) =>
        hasLightColor &&
        css`
            svg g {
                stroke: ${theme.colors.white};
            }
        `};

    ${({ hasWinterWheel }) =>
        hasWinterWheel &&
        css`
            @media ${getBreakpoint("down", "lg")} {
                position: absolute;
                right: 0;
            }
        `};
`;

export const Middle = styled(Flex.Col)<{ interiorSpinFlags?: boolean; isFullscreen?: boolean }>`
    height: auto;

    @media ${getBreakpoint("up", "lg")} {
        height: ${({ interiorSpinFlags }) => (interiorSpinFlags ? "auto" : "240px")};
    }

    @media ${getBreakpoint("up", "lg")} and (max-height: 910px) {
        ${({ isFullscreen, interiorSpinFlags }) =>
            isFullscreen &&
            css`
                height: ${interiorSpinFlags ? "auto" : "180px"};
            `};
    }
`;

export const FinanceToggle = styled.a`
    display: inline-block;
    margin-top: 16px;
    color: ${theme.colors.midnight};
`;
